module.exports = __webpack_public_path__ + "static/img/cabecalho_qma_pdf.b57f945.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/survey/cabecalho_qma_pdf.svg
// module id = aCxX
// module chunks = 0